import React, { createContext, useContext, useMemo, useState, useRef, useCallback } from 'react';
import {
  API_ENV_PROD,
  bindApiEnvironment,
  getApiEnvironment,
  setApiEnvironment as persistApiEnvironment,
} from '../utils/apiEnvironment';

const ApiEnvironmentContext = createContext(null);

export function ApiEnvironmentProvider({ children }) {
  const [apiEnvironment, setApiEnvironmentState] = useState(() => { const value = getApiEnvironment(); bindApiEnvironment(value); return value; });

  const guards = useRef(new Set());
  const registerEnvironmentGuard = useCallback(guard => {
    guards.current.add(guard);
    return () => guards.current.delete(guard);
  }, []);
  const setApiEnvironment = useCallback((nextEnvironment) => {
    if (nextEnvironment === apiEnvironment) return;
    if ([...guards.current].some(guard => !guard())) return;
    const normalized = persistApiEnvironment(nextEnvironment);
    bindApiEnvironment(normalized);
    setApiEnvironmentState(normalized);
  }, [apiEnvironment]);

  const value = useMemo(
    () => ({
      apiEnvironment: apiEnvironment || API_ENV_PROD,
      setApiEnvironment,
      registerEnvironmentGuard,
    }),
    [apiEnvironment, registerEnvironmentGuard, setApiEnvironment]
  );

  return (
    <ApiEnvironmentContext.Provider value={value}>
      {children}
    </ApiEnvironmentContext.Provider>
  );
}

export function useApiEnvironment() {
  const ctx = useContext(ApiEnvironmentContext);
  if (!ctx) throw new Error('useApiEnvironment must be used within ApiEnvironmentProvider');
  return ctx;
}
